module.exports = __webpack_public_path__ + "img/puzzle-treno.20f2eef9.jpg";